module.exports = __webpack_public_path__ + "img/u4679.aa4180a1.svg";